import { Factory } from 'miragejs';

export default Factory.extend({
  createdAt: '2021-08-17T12:31:32.689Z',
  filename: 'document.pdf',
  filesizeBytes: i => 12345 + 324 * i,
  // `url` is generated in the serializer from `id` and `filename`
});
